module.exports = __webpack_public_path__ + "img/comparethemarketcarfinance.testB.6c2ac1cf.svg";